<template>
  <div class="grid grid-cols-2 gap-10">
    <scorecard-tile
      v-for="scorecard in data"
      :key="scorecard.id"
      :scorecard="scorecard"
      :select="select"
      :checked="selectedIds.includes(scorecard.id)"
      @tile-select="handleTileSelect"
    />
  </div>
</template>

<script setup lang="ts">
import ScorecardTile from "./ScorecardTile.vue";

import type { IScorecard } from "@/models/scorecards";
import type { PropType } from "vue";

const emit = defineEmits<{
  "update:selectedIds": [string[]];
}>();

const props = defineProps({
  data: {
    type: Array as PropType<IScorecard[]>,
    required: true,
  },
  select: {
    type: Boolean,
    default: false,
  },
  selectedIds: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
});

const handleTileSelect = (id: string) => {
  const selected = [...props.selectedIds];
  if (selected.includes(id)) {
    selected.splice(selected.indexOf(id), 1);
  } else {
    selected.push(id);
  }
  emit("update:selectedIds", selected);
};
</script>
